import { defineStore, acceptHMRUpdate } from 'pinia';
import i18n from '@/js/plugins/i18n';

const store = defineStore('ui-msgbox', {
  state: () => ({
    list: [],
  }),

  actions: {
    open({ title = '', body = '', buttons = { ok: 'GLOBAL.OK' }, type = 'modal' }) {
      const $t = i18n.global.t;
      if (buttons.ok?.startsWith('GLOBAL.')) buttons.ok = $t(buttons.ok);
      if (buttons.cancel?.startsWith('GLOBAL.')) buttons.cancel = $t(buttons.cancel);
      return new Promise((resolve, reject) => {
        const self = this;
        this.list.push({
          id: window.uuid(),
          type, // modal or vdialog
          title,
          body,
          buttons,
          close() {
            resolve();
            const index = self.list.findIndex(modal => modal.id === this.id);
            if (index > -1) self.list.splice(index, 1);
          },
          dismiss(reason) {
            if (buttons?.cancel) {
              reject(reason);
            } else {
              resolve();
            }
            const index = self.list.findIndex(modal => modal.id === this.id);
            if (index > -1) self.list.splice(index, 1);
          },
        });
      });
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
